var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawChillGuyAvatarTqsm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a-545"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(1129 200)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68 -152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(68 152)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1061 -48)",
    clipPath: "url(#a-545)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1282.835 383.564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.991,81.632a77.011,77.011,0,1,0-100.083,73.49l2.574,148.209L343.189,187.152s-45.895-17.77-54.687-41.318a76.927,76.927,0,0,0,34.489-64.2Z",
    transform: "translate(-88.792 -2.564)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.956,145.878s26.276-9.358,39.746-36.688c12.372-25.1,13.729-67.868-21.4-78.254,0,0,20.239-17.474-17.075-28.12l4.964,4.579s-4.38-7.91-26.009-3.232c0,0-79.924-9.309-94.11,17.007,0,0-42.9,8.791-20.053,41.422,0,0,1.181,6.35,9.332,6.23L188.277,63.5l12.411,5.326s17.262-27.495,33.554-12.292c0,0,31.159-1.311,46.062-4.041,0,0-2.991,40.025,25.612,47.82S316.956,145.878,316.956,145.878Z",
    transform: "translate(-117.59 -2.564)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.614,167.618c-32.442,32.6-63.25,41.349-91.6,14.169L194.983,475.145l16.646,24.119,101.232.288,13.753-331.935Z",
    transform: "translate(-98.23 -2.564)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.546,164.669l16.928,13.913,51.392,29.332A76.58,76.58,0,0,1,188.3,256.9a461.327,461.327,0,0,1,17.4,80.883c8.447,69.355,2.313,160.805,2.313,160.805l-78.132.679,3.4-45.86,12.569-113.461-.333,159.61H54.465s-6.231-270.71,7.347-330.913a7.284,7.284,0,0,1,11.734-3.97Z",
    transform: "translate(160.166 -2.564)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.367,181.787l-61.562,29.6a75.081,75.081,0,0,0-41,52.524L295.009,389.2l-8.43,75.786s36.266,32.479,60.065,21.709l-1.7,12.569h55.032l23.389-317.477Z",
    transform: "translate(-286.579 -2.564)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.031,183.241,202.393,473.7l-3.454-5,40.035-293.358c25.9,24.833,53.852,19.672,83.229-6.266a4.738,4.738,0,0,1,7.875,3.471c-31.14,29.712-60.736,36.888-88.047,10.7Z",
    transform: "translate(-105.651 -2.564)",
    fill: "#090814"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawChillGuyAvatarTqsm);
export default __webpack_public_path__ + "static/media/undraw_chill-guy-avatar_tqsm.d1ae0514509e90fe2c0ad8e7dbe40822.svg";
export { ForwardRef as ReactComponent };